import { useAnimations, useGLTF } from '@react-three/drei'
import { useEffect, useState } from 'react'

export default function Fox()
{
    const fox = useGLTF('./Fox/glTF/Fox.gltf')
    const animations = useAnimations(fox.animations, fox.scene)
    const [currentAnimationIndex, setCurrentAnimationIndex] = useState(0)
    
    useEffect(() => {
        if (animations.names.length === 0) return

        const animationName = animations.names[currentAnimationIndex]
        const action = animations.actions[animationName]
        
        action
            .reset()
            .fadeIn(0.5)
            .play()

        // Set up timer to switch to next animation after 3 seconds
        const timer = setTimeout(() => {
            setCurrentAnimationIndex((prev) => (prev + 1) % animations.names.length)
        }, 3000)

        return () => {
            action.fadeOut(0.5)
            clearTimeout(timer)
        }
    }, [currentAnimationIndex, animations])

    return <primitive
        object={ fox.scene }
        scale={ 0.01 }
        position={ [ -0.2, -0.5, -0.5 ] }
        rotation-y={ 0.3 }
    />
}
